module.exports = __webpack_public_path__ + "img/compare-bulb.c94c865.png";